/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Error_DescriptionInputs */

const fr_app_error_description = /** @type {(inputs: App_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechargez la page pour réessayer.`)
};

const en_app_error_description = /** @type {(inputs: App_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload the page to try again.`)
};

/**
* | output |
* | --- |
* | "Reload the page to try again." |
*
* @param {App_Error_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const app_error_description = /** @type {((inputs?: App_Error_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Error_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_error_description(inputs)
	return fr_app_error_description(inputs)
});